(() => {
  const wholesaleSurfaceSelector = [
    '#swym-component-container',
    '.swym-modal',
    '.swym-sfl-popup',
    '[class*="swym-sfl-popup"]'
  ].join(',');
  const wishlistDialogSelector = '.swym-modal.swym-simple-wishlist-modal .swym-modal-content[role="dialog"]';

  const isWholesale = () => document.body?.classList.contains('wpc-wholesale-authorized');

  const hideWholesaleSurface = (surface) => {
    surface.setAttribute('hidden', '');
    surface.setAttribute('aria-hidden', 'true');
    surface.setAttribute('inert', '');
  };

  const dismissWholesaleSurface = (surface) => {
    if (surface.dataset.wyrdWholesaleDismissed === 'true') return;

    const controls = Array.from(surface.querySelectorAll('button, [role="button"], a'));
    const isSaveForLater = surface.matches('.swym-sfl-popup, [class*="swym-sfl-popup"]')
      || Boolean(surface.querySelector('.swym-sfl-popup, [class*="swym-sfl-popup"]'));
    const noThanks = controls.find((control) => /^no\s*,?\s*thanks!?$/i.test(control.textContent.trim()));
    const cancelControl = controls.find((control) => (
      control.matches('.swym-sfl-popup-cancel, .swym-sfl-popup-cancel-btn, [data-action="cancel"]')
    ));
    const closeControl = !isSaveForLater && controls.find((control) => (
      control.matches('.swym-close-btn, .swym-sfl-popup-close, .swym-sfl-popup-cancel')
      || /^(?:close(?: modal)?|dismiss)$/i.test(control.getAttribute('aria-label') || control.textContent.trim())
    ));
    const dismissControl = noThanks || cancelControl || closeControl;

    if (dismissControl) {
      surface.dataset.wyrdWholesaleDismissed = 'true';
      dismissControl.click();
    }

    window.setTimeout(() => {
      if (surface.isConnected) hideWholesaleSurface(surface);
    }, 0);
  };

  const suppressWholesaleWithin = (root) => {
    const surfaces = [];
    if (root instanceof Element) {
      if (root.matches(wholesaleSurfaceSelector)) surfaces.push(root);
      const containingSurface = root.closest(wholesaleSurfaceSelector);
      if (containingSurface) surfaces.push(containingSurface);
    }
    if (root instanceof Document || root instanceof DocumentFragment || root instanceof Element) {
      surfaces.push(...root.querySelectorAll(wholesaleSurfaceSelector));
    }
    new Set(surfaces).forEach(dismissWholesaleSurface);
  };

  const repairDialog = (dialog) => {
    dialog.setAttribute('aria-modal', 'true');
    if (!dialog.hasAttribute('aria-label') && !dialog.hasAttribute('aria-labelledby')) {
      dialog.setAttribute('aria-label', 'Wishlist');
    }
  };

  const repairWithin = (root) => {
    if (root instanceof Element && root.matches(wishlistDialogSelector)) {
      repairDialog(root);
    }

    if (root instanceof Document || root instanceof DocumentFragment || root instanceof Element) {
      root.querySelectorAll(wishlistDialogSelector).forEach(repairDialog);
    }
  };

  const start = () => {
    const processWithin = isWholesale() ? suppressWholesaleWithin : repairWithin;
    processWithin(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) processWithin(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
